export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
export const SWITCH_LOCATION = "SWITCH_LOCATION";
export const CHECK_MOBILE = "CHECK_MOBILE";
export const RECEIVE_LAGUNA_BEACHSIDE = "RECEIVE_LAGUNA_BEACHSIDE";
export const RECEIVE_LAGUNA_SEASIDE_RESIDENCES =
  "RECEIVE_LAGUNA_SEASIDE_RESIDENCES";
export const RECEIVE_PHUKET_SKYPARK = "RECEIVE_PHUKET_SKYPARK";
export const RECEIVE_PHUKET_LAGUNA_PARK_2 = "RECEIVE_PHUKET_LAGUNA_PARK_2";
export const RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES =
  "RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES";
export const RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA =
  "RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA";
export const RECEIVE_PREVIEW_TRIP = "RECEIVE_PREVIEW_TRIP";
export const RECEIVE_HOME = "RECEIVE_HOME";



// WEBPACK FOOTER //
// ./src/actions/actionType.js